<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

jQuery(document).ready(function(){
  jQuery(".newletterSaverForm h6").click(function(){
    jQuery(".newletterSaverForm form").slideToggle("slow");
  });
  jQuery('.popNewsL').click(function(){
    jQuery("div#SideNewsletterBox").show();
    jQuery("body").addClass("overHide");
  });
  jQuery('.popClose').click(function(){
    jQuery("div#SideNewsletterBox").hide();
    jQuery("body").removeClass("overHide");
  });
})